export const ActionType={
    SET_FLAG:'SET_FLAG',
    SET_LOCAL:'SET_LOCAL'
}